import React from 'react';
import { FileText } from 'lucide-react';

const Blog = () => {
  return (
    <div data-testid="blog-page">
      {/* Hero */}
      <section className="py-10 md:py-24 bg-slate-50">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-heading font-bold text-slate-900 mb-4 md:mb-6 tracking-tight">
            Legal Blog
          </h1>
          <p className="text-base md:text-xl text-slate-600 leading-relaxed">
            Stay informed about personal injury law, your rights, and important legal developments 
            in North Carolina and South Carolina.
          </p>
        </div>
      </section>

      {/* Empty State */}
      <section className="py-10 md:py-24 bg-white">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl">
          <div className="text-center py-8 md:py-16">
            <FileText className="h-16 w-16 md:h-24 md:w-24 text-slate-300 mx-auto mb-4 md:mb-6" />
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-slate-900 mb-4">
              Coming Soon
            </h2>
            <p className="text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto">
              We're preparing valuable content to help you understand your legal rights and options. 
              Check back soon for articles, updates, and insights from our experienced attorneys.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-24 bg-slate-50">
        <div className="container mx-auto px-4 md:px-8 max-w-4xl text-center">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-slate-900 mb-6 tracking-tight">
            Have Questions Now?
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            Don't wait for blog content. Contact us today for personalized legal guidance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-primary text-white px-8 py-4 rounded-sm font-semibold tracking-wider uppercase text-sm shadow-sm hover:bg-primary/90 transition-colors"
              data-testid="cta-consultation"
            >
              Request a Consultation
            </a>
            <a
              href="tel:+13363541040"
              className="border-2 border-primary text-primary px-8 py-4 rounded-sm font-semibold tracking-wider uppercase text-sm hover:bg-primary/10 transition-colors"
              data-testid="cta-call"
            >
              Call 336-354-1040
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;